import { render, staticRenderFns } from "./LvWYSIWYGEditor.vue?vue&type=template&id=a4a4a7dc"
import script from "./LvWYSIWYGEditor.vue?vue&type=script&lang=js"
export * from "./LvWYSIWYGEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports